import { useNavigate, useLocation } from "react-router-dom";
import { WHATSAPP_NUMBER, WHATSAPP_MSG } from "@/data";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const go = (href) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" }), 350);
    } else {
      document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    }
  };
  const waHref = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;
  return (
    <footer className="border-t border-white/10 bg-[#060606]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-10 mb-12">
          <div>
            <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="font-display font-black text-2xl tracking-tighter mb-4 block">
              brand<span className="text-[#ccff00]">to</span>built
            </button>
            <p className="text-zinc-400 max-w-sm mb-2">Your business. Your brand. Your website. Done — in 48 hours.</p>
            <p className="text-zinc-600 text-sm">Done-for-you websites & branding for UK small businesses. From £199.</p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-widest text-zinc-500 mb-4">Explore</p>
            <ul className="flex flex-col gap-3 text-zinc-300">
              <li><button onClick={() => go("#how")} className="hover:text-[#ccff00] transition-colors" data-testid="footer-how">How it works</button></li>
              <li><button onClick={() => go("#score")} className="hover:text-[#ccff00] transition-colors" data-testid="footer-score">Free Website Score</button></li>
              <li><button onClick={() => go("#pricing")} className="hover:text-[#ccff00] transition-colors" data-testid="footer-pricing">Packages & pricing</button></li>
              <li><button onClick={() => go("#plans")} className="hover:text-[#ccff00] transition-colors" data-testid="footer-plans">Care plans</button></li>
              <li><button onClick={() => navigate("/blog")} className="hover:text-[#ccff00] transition-colors" data-testid="footer-blog">Blog</button></li>
              <li><button onClick={() => navigate("/brand")} className="hover:text-[#ccff00] transition-colors" data-testid="footer-brand">Brand kit</button></li>
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-widest text-zinc-500 mb-4">Get in touch</p>
            <ul className="flex flex-col gap-3 text-zinc-300">
              <li><a href={waHref} target="_blank" rel="noopener noreferrer" className="hover:text-[#ccff00] transition-colors" data-testid="footer-whatsapp">WhatsApp us</a></li>
              <li><a href="mailto:hello@brandtobuilt.co.uk" className="hover:text-[#ccff00] transition-colors" data-testid="footer-email">hello@brandtobuilt.co.uk</a></li>
              <li><button onClick={() => go("#contact")} className="hover:text-[#ccff00] transition-colors" data-testid="footer-contact">Start your launch</button></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-sm text-zinc-600">
          <p>© {new Date().getFullYear()} BrandToBuilt · Ainsleys Touch Ltd · brandtobuilt.co.uk</p>
          <div className="flex gap-5">
            <button onClick={() => navigate("/privacy")} className="hover:text-[#ccff00] transition-colors" data-testid="footer-privacy">Privacy</button>
            <button onClick={() => navigate("/terms")} className="hover:text-[#ccff00] transition-colors" data-testid="footer-terms">Terms</button>
            <button onClick={() => navigate("/cookies")} className="hover:text-[#ccff00] transition-colors" data-testid="footer-cookies">Cookies</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
